import gql from 'graphql-tag';

import { TRAVEL_FRAGMENT } from './event.travel';

export const EVENT_INFO = gql`
  ${TRAVEL_FRAGMENT}
  fragment EventInfoFragment on EventInfo {
    id
    location
    date
    greeting
    ownerFirstName
    ownerLastName
    fianceeFirstName
    fianceeLastName
    eventDisplayName
    story
    qanda {
      id
      type
      question
      answer
    }
    registry {
      id
      name
      url
      imageUrl
    }
    toBeAnnouncedSchedule {
      id
      name
      description
      dressCode
      location
      showMap
      placeId
      startTime
      endTime
    }
    formattedSchedule {
      day
      month
      year
      date
      dateString
      items {
        id
        name
        description
        dressCode
        startTime
        endTime
        timezone
        location
        showMap
      }
    }
    ...TravelFragment
  }
`;

// export const UPDATE_EVENT_INFO = gql`
//   mutation updateEventInfo($id: ID!, $eventInfo: EventInfoInput!) {
//     updateEventInfo(id: $id, eventInfo: $eventInfo) {
//       id
//       ownerFirstName
//       ownerLastName
//       fianceeFirstName
//       fianceeLastName
//       greeting
//       story
//       location
//     }
//   }
// `;
